import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-filepicker',
  templateUrl: './filepicker.component.html',
  styleUrls: ['./filepicker.component.scss']
})
export class FilepickerComponent implements OnInit {

  @Input() model?: string;
  @Input() label = 'Upload';
  @Input() accept = 'image/*';
  @Output() modelChange = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  onUpload(event: any): void {
    this.modelChange.emit(event.originalEvent.body.uuid + '.' + event.originalEvent.body.ext);
  }

}
